module.exports = __webpack_public_path__ + "img/logo-government-5.bf3a47af.png";